module.exports = __webpack_public_path__ + "img/logo2.6b6095d1.png";